import React from "react";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import axios from "axios";
import "../stylesheets/resource.scss";
import { NavLink } from "reactstrap";
import { Link, Redirect } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import {
	tableStyle,
	dateCol,
} from "../ticketModule/variables/ListingVariables";
import { Feedback_APIs } from "./Feedback_APIs";
import { UserConsumer } from "../../UserContext";
import Edit from "../../images/edit.svg";
import Delete from "../../images/delete.svg";
import CreateFeedback from "./CreateFeedback";
import Header from "../timesheetModule/Header";
import { Table } from "../../components/CustomPaginations";
import { statusColor } from "../../components/TableStyle";
import { AlertPopups } from "../../components/AlertPopups";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../components/GlobalPaginationSize";
import { Routes } from "../../configurations/config";
let token = null;
let empDesignation = null;
class FeedbackList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showFeedback: false,
			error: null,
			isLoaded: false,
			items: [],
			toggledClearRows: false,
			showLoader: false,
			currentPage: 1,
			pageList: [],
			refresh: false,
			pageNum: 1,
			numberOfItemsPerPage: GlobalPaginationSize.defaultPaginationSize,
			pagerDate: [],
			sortBy: {
				dataField: "id",
				order: "desc",
			},
		};
		this.input = React.createRef();
	}
	defaultSorted = [
		{
			dataField: "id",
			order: "desc",
		},
	];
	devIds = [
		"393",// Added Zeeshan id
		"312",
		"180",
		"51",
		"251",
		"168",
		"801",
		"137",
	];
	getColumns = () => {
		return [
			{
				dataField: "id",
				text: "Bug ID",
				sort: true,
				headerStyle: {
					width: "15%",
				},
			},
			{
				dataField: "title",
				text: "Title",
				sort: true,
				formatter: (cell, row) => {
					return row.title ? (
						<div title={row.title}>
							{row.title.length > 30
								? row.title.substring(0, 30) + "..."
								: row.title}
						</div>
					) : (
						"N/A"
					);
				},
				headerStyle: {
					width: "30%",
				},
			},
			{
				dataField: "priority",
				text: "Priority",
				formatter: (cell, row) => {
					return row.priority === 1
						? "High"
						: row.priority === 2
						? "Medium"
						: row.priority === 3
						? "Low"
						: "N/A";
				},
				headerStyle: {
					width: "20%",
				},
			},
			{
				dataField: "BugStatusEnum",
				text: "Status",
				formatter: (cell, row) => {
					return this.getStatusForEnum(row.bugStatusEnum);
				},
				style: (cell, row) => {
					return statusColor(
						this.getStatusForEnum(row.bugStatusEnum)
					);
				},
				headerStyle: {
					width: "20%",
				},
			},
			{
				dataField: "createdBy",
				text: "Created By",
				hidden: window.location.pathname === Routes.Bug,
				formatter: (cell, row) => {
					return row.empName ? row.empName : row.createdBy;
				},
				headerStyle: {
					width: "30%",
				},
			},
			{
				dataField: "createdAt",
				text: "Create Date",
				formatter: dateCol,
				sort: true,
				headerStyle: {
					width: "20%",
				},
			},
			{
				dataField: "link",
				text: "Action",
				events: {
					onClick: (e) => {
						e.stopPropagation(); // To stop navigation to detail screen
					},
				},
				formatter: (cell, row) => {
					return this.state.showFeedback ? (
						<div className="navLinkClass">
							<Link
								className="tickeIdClass idHover align-self-end"
								to={{
									pathname: `/feedbackDetails/${row.id}`,
									state: {
										currentPage: this.state.currentPage,
										showFeedback: this.state.showFeedback,
									},
								}}
							>
								<button
									className="btnStyle"
									title="View Detail"
								>
									<FontAwesomeIcon
										id="edit"
										className="hoverEffect"
										icon={faEye}
										style={{
											height: "24px",
											width: "20px",
											cursor: "pointer",
										}}
									/>
								</button>
							</Link>
							{this.getStatusForEnum(row.bugStatusEnum) ===
							"Completed" ? null : (
								<Link
									to={{
										pathname: `/editBug/${row.id}`,
										state: {
											currentPage: this.state.currentPage,
											showFeedback:
												this.state.showFeedback,
											itemStatus: this.getStatusForEnum(
												row.bugStatusEnum
											),
										},
									}}
								>
									<img
										title="Edit"
										style={{
											height: "20px",
											width: "20px",
											marginLeft: "10px",
										}}
										src={Edit}
										alt="Edit"
									/>
								</Link>
							)}

							<NavLink
								onClick={(e) => {
									this.deleteFeedback(row.id, e);
								}}
							>
								<img
									title="Delete"
									style={{
										height: "18px",
										width: "18px",
										cursor: "pointer",
									}}
									src={Delete}
									alt="Delete"
								/>
							</NavLink>
						</div>
					) : (
						<div>
							<Link
								to={{
									pathname: `/feedbackStatusDetails/${row.id}`,
									state: {
										currentPage: this.state.currentPage,
									},
								}}
							>
								<button
									className="btnStyle"
									title="View Detail"
								>
									<FontAwesomeIcon
										id="edit"
										className="hoverEffect"
										icon={faEye}
										size="1x"
									/>
								</button>
							</Link>
						</div>
					);
				},
				headerStyle: {
					width: "15%",
				},
			},
		];
	};
	SearchBar = () => {
		const handleClick = (e) => {
			const value = this.input.value;
			this.setState({
				input: value,
				pageNum: 1,
			});
			const headers = {
				Authorization: `Bearer ${token}`,
			};

			if (value === "") {
				this.setState({ tableLoader: true }, () => {
					axios
						.get(
							`${
								window.location.pathname === Routes.Bug
									? Feedback_APIs.GetAllFeedbacks_API
									: Feedback_APIs.GetAllEmpFeedbacks_API
							}?PageNumber=${1}&PageSize=${
								this.state.numberOfItemsPerPage
							}&SortBy=${this.state.sortBy.dataField}_${
								this.state.sortBy.order
							}`,
							{ headers: headers }
						)
						.then((res) => {
							const items = res.data;
							this.setState({
								items,
								tableLoader: !this.state.tableLoader,
								pagerData: JSON.parse(
									res.headers["x-pagination"]
								),
							});
						});
				});
			} else {
				this.setState({ tableLoader: true }, () => {
					axios
						.get(
							`${
								window.location.pathname === Routes.Bug
									? Feedback_APIs.GetAllFeedbacks_API
									: Feedback_APIs.GetAllEmpFeedbacks_API
							}?PageNumber=${1}&PageSize=${
								this.state.numberOfItemsPerPage
							}&SortBy=${this.state.sortBy.dataField}_${
								this.state.sortBy.order
							}&SearchTerm=${value}`,
							{ headers: headers }
						)
						.then((res) => {
							const items = res.data;
							this.setState({
								items,
								tableLoader: !this.state.tableLoader,
								pagerData: JSON.parse(
									res.headers["x-pagination"]
								),
							});
						});
				});
			}
		};
		return (
			<div className="col-lg-3 mb-2">
				<input
					className="form-control resourceTickets-SearchBar"
					ref={(n) => (this.input = n)}
					type="text"
					onChange={handleClick}
					onFocus={() => this.setState({ currentPage: 1 })}
					placeholder="Search"
				/>
			</div>
		);
	};
	getStatusForEnum(bugStatusEnum) {
		return bugStatusEnum === 1
			? "Pending"
			: bugStatusEnum === 2
			? "InProgress"
			: bugStatusEnum === 3
			? "Completed"
			: bugStatusEnum === 4
			? "Deferred"
			: "Pending";
	}
	static getDerivedStateFromProps(nextProps, prevState) {
		return {
			currentPage:
				nextProps.history &&
				nextProps.history.location &&
				nextProps.history.location.state
					? nextProps.history.location.state.currentPage
					: prevState.currentPage,
			showFeedback:
				nextProps.history &&
				nextProps.history.location &&
				nextProps.history.location.state
					? nextProps.history.location.state.showFeedback
					: prevState.showFeedback,
		};
	}
	componentDidMount() {
		let pageSize = getPaginationSizeOnRole(empDesignation);
		this.setState({
			numberOfItemsPerPage: pageSize,
		});
		const { history } = this.props;
		history && history.replace();

		if (window.location.pathname === Routes.Bug) {
			this.setState({ showFeedback: true });
			this.getAllFeedbacks();
		} else this.getEmpFeedback();
	}
	componentDidUpdate(prevProps) {
		if (prevProps.reload !== true && this.props.reload === true) {
			this.getAllFeedbacks();
		}
	}
	getAllFeedbacks = () => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};

		this.setState({ showLoader: true }, () => {
			axios
				.get(
					`${Feedback_APIs.GetAllFeedbacks_API}?PageSize=${this.state.numberOfItemsPerPage}&SortBy=${this.state.sortBy.dataField}_${this.state.sortBy.order}`,
					{
						headers: headers,
					}
				)
				.then((res) => {
					let items = res.data;
					this.setState({
						items,
						showLoader: !this.state.showLoader,
						pagerData: JSON.parse(res.headers["x-pagination"]),
					});
				});
		});
	};
	getEmpFeedback = () => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		this.setState({ showLoader: true }, () => {
			axios
				.get(
					`${Feedback_APIs.GetAllEmpFeedbacks_API}?PageNumber=${this.state.pageNum}&PageSize=${this.state.numberOfItemsPerPage}&SortBy=${this.state.sortBy.dataField}_${this.state.sortBy.order}`,
					{
						headers: headers,
					}
				)
				.then((res) => {
					let items = res.data;
					this.setState({
						items,
						showLoader: !this.state.showLoader,
						pagerData: JSON.parse(res.headers["x-pagination"]),
					});
				});
		});
	};
	deleteFeedback = (id) => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		AlertPopups.confirmBox
			.fire({
				text: AlertPopups.confirmMsg,
			})
			.then((result) => {
				if (result.value) {
					this.setState({ showLoader: true }, () => {
						axios
							.delete(
								`${Feedback_APIs.DeleteFeedback_API}${id}`,
								{
									headers: headers,
								}
							)
							.then((res) => {
								if (res.status === 204) {
									AlertPopups.InfoAlert.fire({
										text: "Feedback deleted",
									});
									this.setState(
										{
											showLoader: !this.state.showLoader,
										},
										() => {
											this.getAllFeedbacks();
										}
									);
								}
							});
					});
				}
			});
	};

	receiveData = (PageSize) => {
		let apiURL = "";

		if (window.location.pathname === Routes.Bug)
			apiURL = `${
				Feedback_APIs.GetAllFeedbacks_API
			}?PageNumber=${1}&PageSize=${PageSize}&SortBy=${
				this.state.sortBy.dataField
			}_${this.state.sortBy.order}`;
		else
			apiURL = `${
				Feedback_APIs.GetAllEmpFeedbacks_API
			}?PageNumber=${1}&PageSize=${PageSize}&SortBy=${
				this.state.sortBy.dataField
			}_${this.state.sortBy.order}`;

		axios
			.get(apiURL, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {
				let items = res.data;
				if (res.status === 200) {
					this.setState({
						pageNum: 1,
						numberOfItemsPerPage: PageSize,
						pagerData: JSON.parse(res.headers["x-pagination"]),
						items: items,
					});
				}
			});
	};
	handleTableChange = (type, { page, sortOrder, sortField }) => {
		let getData = false;
		let apiURL = "";
		if (type === "sort") {
			apiURL = `${
				window.location.pathname === Routes.Bug
					? Feedback_APIs.GetAllFeedbacks_API
					: Feedback_APIs.GetAllEmpFeedbacks_API
			}?PageNumber=${page}&PageSize=${
				this.state.numberOfItemsPerPage
			}&SortBy=${sortField}_${sortOrder}`;

			this.setState({
				sortBy: { dataField: sortField, order: sortOrder },
			});
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${
				window.location.pathname === Routes.Bug
					? Feedback_APIs.GetAllFeedbacks_API
					: Feedback_APIs.GetAllEmpFeedbacks_API
			}?PageNumber=${page}&PageSize=${
				this.state.numberOfItemsPerPage
			}&SortBy=${this.state.sortBy.dataField}_${this.state.sortBy.order}`;
			getData = true;
		}

		if (getData) {
			axios
				.get(apiURL, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then((res) => {
					let items = res.data;
					if (res.status === 200) {
						this.setState({
							pageNum: page,
							pagerData: JSON.parse(res.headers["x-pagination"]),
							items: items,
						});
					}
				});
		}
	};
	render() {
		return (
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;
					empDesignation = userDetails.designation;
					return window.location.pathname === Routes.ReportedBugs ? (
						userDetails.designation.toString() === "4" ||
						this.devIds.includes(userDetails.id.toString()) ? (
							<div className="container-fluid pl-2 ">
								<Header
									title={
										this.state.showFeedback
											? "Report a Bug"
											: "Reported Bugs"
									}
								/>
								{this.state.showFeedback ? (
									<CreateFeedback
										reloadList={this.getAllFeedbacks}
									/>
								) : null}
								<PaginationProvider
									pagination={paginationFactory({
										custom: true,
										totalSize: this.state.pagerData
											? this.state.pagerData.TotalCount
											: 0,
										page: this.state.pageNum,
										sizePerPage:
											this.state.numberOfItemsPerPage,
										paginationSize:
											this.state.numberOfItemsPerPage,
									})}
								>
									{({
										paginationProps,
										paginationTableProps,
									}) => {
										return (
											<Table
												columns={this.getColumns()}
												items={this.state.items}
												tableStyle={tableStyle}
												paginationProps={
													paginationProps
												}
												paginationTableProps={
													paginationTableProps
												}
												onTablePageChange={
													this.handleTableChange
												}
												defaultSorted={
													this.defaultSorted
												}
												tableLoader={
													this.state.showLoader
												}
												showFeedback={
													this.state.showFeedback
												}
												SearchBar={
													!this.state.showFeedback &&
													this.SearchBar
												}
												inputValue={
													!this.state.showFeedback &&
													this.input.value
												}
												keyField={"id"}
												receiveData={(PageSize) => {
													this.receiveData(PageSize);
												}}
												pagerData={
													this.state?.pagerData
												}
												rowEvents={{
													onClick: (e, row) => {
														this.props.history.push(
															{
																pathname: `/feedbackStatusDetails/${row.id}`,
																state: {
																	currentPage:
																		this
																			.state
																			.currentPage,
																},
															}
														);
													},
												}}
											/>
										);
									}}
								</PaginationProvider>
							</div>
						) : (
							<Redirect to="/MyDashboard" />
						)
					) : (
						<div className="container-fluid pl-2 ">
							<Header
								title={
									this.state.showFeedback
										? "Report a Bug"
										: "Reported Bugs"
								}
							/>
							{this.state.showFeedback ? (
								<CreateFeedback
									reloadList={this.getAllFeedbacks}
								/>
							) : null}
							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: this.state.pagerData
										? this.state.pagerData.TotalCount
										: 0,
									page: this.state.pageNum,
									sizePerPage:
										this.state.numberOfItemsPerPage,
									paginationSize:
										this.state.numberOfItemsPerPage,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											columns={this.getColumns()}
											items={this.state.items}
											tableStyle={tableStyle}
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												this.handleTableChange
											}
											defaultSorted={this.defaultSorted}
											tableLoader={this.state.showLoader}
											showFeedback={
												this.state.showFeedback
											}
											SearchBar={
												!this.state.showFeedback &&
												this.SearchBar
											}
											inputValue={
												!this.state.showFeedback &&
												this.input.value
											}
											keyField={"id"}
											receiveData={(PageSize) => {
												this.receiveData(PageSize);
											}}
											pagerData={this.state?.pagerData}
											rowEvents={{
												onClick: (e, row) => {
													this.props.history.push({
														pathname: `/feedbackDetails/${row.id}`,
														state: {
															currentPage:
																this.state
																	.currentPage,
															showFeedback:
																this.state
																	.showFeedback,
														},
													});
												},
											}}
										/>
									);
								}}
							</PaginationProvider>
						</div>
					);
				}}
			</UserConsumer>
		);
	}
}
export default FeedbackList;
